import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const FacebookIcon = ({ className = '', color = 'currentColor' }) => {
    return (
        <svg
            className={`logo-24-24 ${className ? className : ''}`}
            fill='none'
            height='23'
            viewBox='0 0 23 23'
            width='23'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M3.13636 0.000488281H19.8636C21.6096 0.000488281 23 1.39091 23 3.13685V19.8641C23 21.6101 21.6096 23.0005 19.8636 23.0005H16.5272V14.5674H19.4471L19.8841 11.2024H16.5272V9.05837C16.5272 8.08401 16.7984 7.42076 18.2056 7.42076H20.0025V4.411C19.6909 4.36918 18.6247 4.28032 17.3848 4.28032C14.7962 4.28032 13.0273 5.84641 13.0273 8.7235V11.2024L10.4545 11.1942V14.5593L13.0273 14.5674V23.0005H3.13636C1.39042 23.0005 0 21.6101 0 19.8641V3.13685C0 1.39091 1.39042 0.000488281 3.13636 0.000488281Z'
                fill={color}/>
        </svg>


    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default FacebookIcon;
